export default __webpack_public_path__ + "7ceb0b607f7eb21fbacb7254cc69696a.png";